import {graphql} from 'react-apollo';
import {fetchPreviewsQuery} from '../../graphql';

export const defaultVariables = {
    pageSize: 200,
    listingPageSize: 4
};

export const readPreviewsCache = (proxy, hav, pageSize, listingPageSize) =>
    proxy.readQuery({query: fetchPreviewsQuery, variables: {hav, pageSize, listingPageSize}});

export const writePreviewsCache = (proxy, hav, pageSize, listingPageSize, cache) =>
    proxy.writeQuery({query: fetchPreviewsQuery, variables: {hav, pageSize, listingPageSize}, data: cache});

const withFetchPreviewsQuery = graphql(fetchPreviewsQuery, {
    options: ({
        hav,
        pageSize = defaultVariables.pageSize,
        listingPageSize = defaultVariables.listingPageSize,
        fetchTripboardsQueryConfig
    }) => ({
        ...fetchTripboardsQueryConfig,
        variables: {hav, pageSize, listingPageSize}
    }),
    name: 'tripboardData',
    alias: 'withFetchPreviewsQuery',
    skip: ({hav}) => !hav
});

export default withFetchPreviewsQuery;
